import { ReactElement } from 'react'
import { ApplicationDetailsIndex } from 'src/screens/shared/application/details/ApplicationDetailsIndex'

export const PfKapApplicationDetailsIndexPage = (): ReactElement => {
  return <ApplicationDetailsIndex baseUrl="/pf-kap" />
}
